import formComponent from '@/util/proto/formComponent'
import { phoneValidator , idNumberValidator } from '@/util/validator'
import Range from './partial/range'
import { timeDisplay } from '@/util/format/duration'

export default {
  extends: formComponent ,
  components:{ },
  data() {
    return {
      formData: {
        price: {
          rules:[
            { required: true, type:'number', message: '价格不能为空', trigger: 'blur,change' },
          ]
        },
        districtCodes: {
          rules:[
            { required: true, type: 'array', required: false, message: '请选择区域', trigger: 'blur,change' },
          ]
        },
        remark:null
        
      },
      state:{
        intervals:[]
      },
      id:null,
      loading:false,
      visible:false,
      api:['assFeeTplCreate','assFeeTplUpdate'],
    }
  },

  computed:{
    title(){
      return this.id ? '修改区域价格' : '新增区域价格'
    }
  },

  methods: {
    init(id) {
      this.id = id
      this.visible = true
      this.$resetFormData()
      this.state.intervals = []
      if (this.id) {
        this.query()
      }
    },

    query(){
      this.loading = true
      this.$request.assFeeTpl(this.id).then(resp => {
        this.$setFormData(resp.data)
        this.state.intervals = resp.data.intervals || []
        this.loading = false
      })
    },
    beforeSave(d){
      let params = { ...d }
      if(this.id){
        params.id = this.id
      }

      params.intervals = this.state.intervals
      return params
    },
    handleCreateRange(){
      this.$dialog({
        title:'新增时段价格',
        width:450,
        paddingless:true,
        render:(h)=>{
          return <Range validator={(v) => this.check(v)} />
        },
        onOk:({data})=>{
          this.state.intervals.push( data )
        }
      })
    },
    check(a){
      const intervals = this.state.intervals || []
      if(a && Array.isArray(a) && a.length == 2){
        for(let i of intervals){
          let b = [i.startDatetime , i.endDatetime]
          if( (a[0] <= b[1] && a[0] >= b[0]) || (a[1] <= b[1] && a[1] >= b[0]) ){
            return false 
          }
        }
        return true
      }else{
        return false
      }
    },
    removeRange(idx){
      this.state.intervals.splice(idx , 1)
    },
    createTable(){
      const columns = [
        { title: '时段',  key: 'range', width: 160, render:(h,{row}) => {
          return <span>{timeDisplay(row.startDatetime) + ' - ' + timeDisplay(row.endDatetime)}</span>
        }},
        { title: '价格',  key: 'price', width: 100, },
        { 
          title: '操作',  key: 'operation',
          width: 100,
          render: (h, {index}) => {
            return <a on-click={()=>this.removeRange(index)}>删除</a>
          }},
      ]

      const data = this.state.intervals
      return (
        <sl-table size="small" page={false} columns={columns} data={data} />
      )
    }
  },

  render(){
    return (
      <sl-side-panel v-model={this.visible} loading={this.loading} title={this.title}>
        <sl-form label-width={100}>
          <sl-form-item label="区域">
            <sl-city-select v-decorator={this.formData.districtCodes} />
          </sl-form-item>
          <sl-form-item label="价格">
            <InputNumber v-decorator={this.formData.price} />
          </sl-form-item>
          <sl-form-item label="时段价格">
            <Button icon="md-add" style="margin-bottom:8px;" on-click={this.handleCreateRange}>新增</Button>
            {this.createTable()}
          </sl-form-item>
        </sl-form>
        <template slot="footer">
          <Button loading={this.loading} on-click={this.$handleSubmit} type="primary">确定</Button>
        </template>
      </sl-side-panel>
    )
  }
}